export async function AnaliticasCreate(
  analiFecha,
  analiFechaAnali,
  analiName,
  analiSurname,
  analiDni,
  analiNhc,
  analiBed,
  analiSex,
  analiOrigen,
  analiDoctor,
  analiObs,
  analiHematiesResult,
  analiHematiesLow,
  analiHematiesHigh,
  analiHemoglobResult,
  analiHemoglobLow,
  analiHemoglobHigh,
  analiHematcrResult,
  analiHematcrLow,
  analiHematcrHigh,
  analiVcmResult,
  analiVcmLow,
  analiVcmHigh,
  analiHcmResult,
  analiHcmLow,
  analiHcmHigh,
  analiChcmResult,
  analiChcmLow,
  analiChcmHigh,
  analiIdhResult,
  analiIdhLow,
  analiIdhHigh,
  analiLeucoResult,
  analiLeucoLow,
  analiLeucoHigh,
  analiNeutrResult,
  analiNeutrLow,
  analiNeutrHigh,
  analiLinfoResult,
  analiLinfoLow,
  analiLinfoHigh,
  analiMonocResult,
  analiMonocLow,
  analiMonocHigh,
  analiEosinResult,
  analiEosinLow,
  analiEosinHigh,
  analiBasofResult,
  analiBasofLow,
  analiBasofHigh,
  analiPlaqResult,
  analiPlaqLow,
  analiPlaqHigh,
  analiPctResult,
  analiPctLow,
  analiPctHigh,
  analiVpmResult,
  analiVpmLow,
  analiVpmHigh,
  analiIdpResult,
  analiIdpLow,
  analiIdpHigh,
  analiTieProtResult,
  analiTieProtLow,
  analiTieProtHigh,
  analiActProtResult,
  analiActProtLow,
  analiActProtHigh,
  analiInrResult,
  analiInrLow,
  analiInrHigh,
  analiGlucResult,
  analiGlucLow,
  analiGlucHigh,
  analiUreaResult,
  analiUreaLow,
  analiUreaHigh,
  analiCreatResult,
  analiCreatLow,
  analiCreatHigh,
  analiGlomResult,
  analiGlomLow,
  analiGlomHigh,
  analiAsparResult,
  analiAsparLow,
  analiAsparHigh,
  analiAlanResult,
  analiAlanLow,
  analiAlanHigh,
  analiGammResult,
  analiGammLow,
  analiGammHigh,
  analiFosfResult,
  analiFosfLow,
  analiFosfHigh,
  analiBiliResult,
  analiBiliLow,
  analiBiliHigh,
  analiColestResult,
  analiColestLow,
  analiColestHigh,
  analiColestHdlResult,
  analiColestHdlLow,
  analiColestHdlHigh,
  analiColestLdlResult,
  analiColestLdlLow,
  analiColestLdlHigh,
  analiTriglResult,
  analiTriglLow,
  analiTriglHigh,
  analiCalcResult,
  analiCalcLow,
  analiCalcHigh,
  analiHierrResult,
  analiHierrLow,
  analiHierrHigh,
  analiSodResult,
  analiSodLow,
  analiSodHigh,
  analiPotasResult,
  analiPotasLow,
  analiPotasHigh,
  analiVitbResult,
  analiVitbLow,
  analiVitbHigh,
  analiVitohResult,
  analiVitohLow,
  analiVitohHigh,
  analiAcidfolResult,
  analiAcidfolLow,
  analiAcidfolHigh,
  analiMagnResult,
  analiMagnLow,
  analiMagnHigh,
  analiFerriResult,
  analiFerriLow,
  analiFerriHigh,
  analiProtcResult,
  analiProtcLow,
  analiProtcHigh,
  analiCortiResult,
  analiCortiLow,
  analiCortiHigh,
  analiDheaResult,
  analiDheaLow,
  analiDheaHigh,
  analiDheaSResult,
  analiDheaSLow,
  analiDheaSHigh,
  isNotJson,
  analiticaIsSecond,
  analiFileUrl,
  analiticaJson,
  tratamientoId,
  pacienteId
) {
  let analiFileLink = "";
  if (analiFileUrl) {
    analiFileLink = analiFileUrl;
  }
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-anal-${analiFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-anal-${analiFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      analiResp: analiDoctor,
      metaFecha: analiFecha,
      metaPaciente: pacienteId,
      analiFechaAnali: analiFechaAnali,
      analiName: analiName,
      analiSurname: analiSurname,
      analiDni: analiDni,
      analiNhc: analiNhc,
      analiBed: analiBed,
      analiSex: analiSex,
      analiOrigen: analiOrigen,
      analiDoctor: analiDoctor,
      analiObs: analiObs,
      analiHematiesResult: analiHematiesResult,
      analiHematiesLow: analiHematiesLow,
      analiHematiesHigh: analiHematiesHigh,
      analiHemoglobResult: analiHemoglobResult,
      analiHemoglobLow: analiHemoglobLow,
      analiHemoglobHigh: analiHemoglobHigh,
      analiHematcrResult: analiHematcrResult,
      analiHematcrLow: analiHematcrLow,
      analiHematcrHigh: analiHematcrHigh,
      analiVcmResult: analiVcmResult,
      analiVcmLow: analiVcmLow,
      analiVcmHigh: analiVcmHigh,
      analiHcmResult: analiHcmResult,
      analiHcmLow: analiHcmLow,
      analiHcmHigh: analiHcmHigh,
      analiChcmResult: analiChcmResult,
      analiChcmLow: analiChcmLow,
      analiChcmHigh: analiChcmHigh,
      analiIdhResult: analiIdhResult,
      analiIdhLow: analiIdhLow,
      analiIdhHigh: analiIdhHigh,
      analiLeucoResult: analiLeucoResult,
      analiLeucoLow: analiLeucoLow,
      analiLeucoHigh: analiLeucoHigh,
      analiNeutrResult: analiNeutrResult,
      analiNeutrLow: analiNeutrLow,
      analiNeutrHigh: analiNeutrHigh,
      analiLinfoResult: analiLinfoResult,
      analiLinfoLow: analiLinfoLow,
      analiLinfoHigh: analiLinfoHigh,
      analiMonocResult: analiMonocResult,
      analiMonocLow: analiMonocLow,
      analiMonocHigh: analiMonocHigh,
      analiEosinResult: analiEosinResult,
      analiEosinLow: analiEosinLow,
      analiEosinHigh: analiEosinHigh,
      analiBasofResult: analiBasofResult,
      analiBasofLow: analiBasofLow,
      analiBasofHigh: analiBasofHigh,
      analiPlaqResult: analiPlaqResult,
      analiPlaqLow: analiPlaqLow,
      analiPlaqHigh: analiPlaqHigh,
      analiPctResult: analiPctResult,
      analiPctLow: analiPctLow,
      analiPctHigh: analiPctHigh,
      analiVpmResult: analiVpmResult,
      analiVpmLow: analiVpmLow,
      analiVpmHigh: analiVpmHigh,
      analiIdpResult: analiIdpResult,
      analiIdpLow: analiIdpLow,
      analiIdpHigh: analiIdpHigh,
      analiTieProtResult: analiTieProtResult,
      analiTieProtLow: analiTieProtLow,
      analiTieProtHigh: analiTieProtHigh,
      analiActProtResult: analiActProtResult,
      analiActProtLow: analiActProtLow,
      analiActProtHigh: analiActProtHigh,
      analiInrResult: analiInrResult,
      analiInrLow: analiInrLow,
      analiInrHigh: analiInrHigh,
      analiGlucResult: analiGlucResult,
      analiGlucLow: analiGlucLow,
      analiGlucHigh: analiGlucHigh,
      analiUreaResult: analiUreaResult,
      analiUreaLow: analiUreaLow,
      analiUreaHigh: analiUreaHigh,
      analiCreatResult: analiCreatResult,
      analiCreatLow: analiCreatLow,
      analiCreatHigh: analiCreatHigh,
      analiGlomResult: analiGlomResult,
      analiGlomLow: analiGlomLow,
      analiGlomHigh: analiGlomHigh,
      analiAsparResult: analiAsparResult,
      analiAsparLow: analiAsparLow,
      analiAsparHigh: analiAsparHigh,
      analiAlanResult: analiAlanResult,
      analiAlanLow: analiAlanLow,
      analiAlanHigh: analiAlanHigh,
      analiGammResult: analiGammResult,
      analiGammLow: analiGammLow,
      analiGammHigh: analiGammHigh,
      analiFosfResult: analiFosfResult,
      analiFosfLow: analiFosfLow,
      analiFosfHigh: analiFosfHigh,
      analiBiliResult: analiBiliResult,
      analiBiliLow: analiBiliLow,
      analiBiliHigh: analiBiliHigh,
      analiColestResult: analiColestResult,
      analiColestLow: analiColestLow,
      analiColestHigh: analiColestHigh,
      analiColestHdlResult: analiColestHdlResult,
      analiColestHdlLow: analiColestHdlLow,
      analiColestHdlHigh: analiColestHdlHigh,
      analiColestLdlResult: analiColestLdlResult,
      analiColestLdlLow: analiColestLdlLow,
      analiColestLdlHigh: analiColestLdlHigh,
      analiTriglResult: analiTriglResult,
      analiTriglLow: analiTriglLow,
      analiTriglHigh: analiTriglHigh,
      analiCalcResult: analiCalcResult,
      analiCalcLow: analiCalcLow,
      analiCalcHigh: analiCalcHigh,
      analiHierrResult: analiHierrResult,
      analiHierrLow: analiHierrLow,
      analiHierrHigh: analiHierrHigh,
      analiSodResult: analiSodResult,
      analiSodLow: analiSodLow,
      analiSodHigh: analiSodHigh,
      analiPotasResult: analiPotasResult,
      analiPotasLow: analiPotasLow,
      analiPotasHigh: analiPotasHigh,
      analiVitbResult: analiVitbResult,
      analiVitbLow: analiVitbLow,
      analiVitbHigh: analiVitbHigh,
      analiVitohResult: analiVitohResult,
      analiVitohLow: analiVitohLow,
      analiVitohHigh: analiVitohHigh,
      analiAcidfolResult: analiAcidfolResult,
      analiAcidfolLow: analiAcidfolLow,
      analiAcidfolHigh: analiAcidfolHigh,
      analiMagnResult: analiMagnResult,
      analiMagnLow: analiMagnLow,
      analiMagnHigh: analiMagnHigh,
      analiFerriResult: analiFerriResult,
      analiFerriLow: analiFerriLow,
      analiFerriHigh: analiFerriHigh,
      analiProtcResult: analiProtcResult,
      analiProtcLow: analiProtcLow,
      analiProtcHigh: analiProtcHigh,
      analiCortiResult: analiCortiResult,
      analiCortiLow: analiCortiLow,
      analiCortiHigh: analiCortiHigh,
      analiDheaResult: analiDheaResult,
      analiDheaLow: analiDheaLow,
      analiDheaHigh: analiDheaHigh,
      analiDheaSResult: analiDheaSResult,
      analiDheaSLow: analiDheaSLow,
      analiDheaSHigh: analiDheaSHigh,
      isNotJson: isNotJson,
      analiticaIsSecond: analiticaIsSecond,
      analiFileLink: analiFileLink,
      analiticaJson: analiticaJson,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/analiticas",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
